module.exports = __webpack_public_path__ + "static/media/pdf.6f0c0998.svg";